import React from "react";
import PropTypes from "prop-types";
import "./Home.css";
import { connect } from "react-redux";
import { Set } from "immutable";
import User from "../../models/User";
import { CURRENT_TITLE } from "../../constants";
import { useNavigate } from "react-router-dom";

import { openModal } from "../../actions/ui-actions";

import Button from "@mui/material/Button";
import NewGroupModal from "../group/newGroupModal/NewGroupModal";
import { gameNomineesSelector } from "../../selectors/nominees-selector";

const Home = ({ currentUser, nominees, onClickNewGroup }) => {
  const navigate = useNavigate();

  return (
    <div className="Home">
      <div className="Home-header">
        <h1 className="Home-awards-title">{CURRENT_TITLE}</h1>
        <h2 className="Home-main-title">
          Pick the <span className="Home-gold-text">winners</span>. Beat your
          friends.
        </h2>
        {true ? (
          <Button
            variant="contained"
            sx={{
              color: "#424242",
            }}
            onClick={() => {
              currentUser.id
                ? onClickNewGroup("NEW_GROUP")
                : navigate("/login");
            }}
          >
            Start a group
          </Button>
        ) : (
          <div className="Home-game-complete-message">
            Note: The 2018 Oscars are complete! Please check back for the next
            event.
          </div>
        )}
      </div>
      <div className="Home-movie-carousel">
        <div className="Home-movie-images">
          {nominees.map((nominee) => {
            return (
              <div
                key={nominee.get("id")}
                className="Home-nominee-poster"
                style={{
                  backgroundImage: `url(${nominee.get("imageUrl")})`,
                }}
              />
            );
          })}
        </div>
      </div>
      <NewGroupModal />
    </div>
  );
};

Home.propTypes = {
  currentUser: PropTypes.instanceOf(User),
  nominees: PropTypes.instanceOf(Set),
  onClickNewGroup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    nominees: gameNomineesSelector(state),
  };
};

export default connect(mapStateToProps, {
  onClickNewGroup: openModal,
})(Home);
